<template>
  <div class="page">
    <div class="router">
      <div @click="$router.go(-1)" class="back">
        <a-icon type="left"></a-icon>
        <div class="name">返回</div>
      </div>
      <div class="extra">
        <a-space>
          <a-button size="small" shape="round" @click="handleSave"
            >暂存</a-button
          >
          <a-button
            type="primary"
            shape="round"
            @click="handlePush"
            size="small"
            >立即发布</a-button
          >
        </a-space>
      </div>
    </div>

    <div class="srcoll">
      <div class="head flex-row">
        <div class="title">王泽 任务详情</div>
      </div>

      <section class="section">
        <div class="z-title">观察实录</div>
        <div class="input">
          <a-textarea
            placeholder="填写记录"
            v-model="form.content2"
            :rows="4"
            :maxLength="3000"
            style="border: none;"
          />
          <div class="number">{{ form.content2.length }}/3000</div>
        </div>

        <div class="upload">
          <a-upload
            :style="{ width: (fileList.length + 1) * 120 + 'px' }"
            name="avatar"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="true"
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            @change="handleChange1"
          >
            <div>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">
                点击上传照片/视频
              </div>
            </div>
          </a-upload>
          <a-upload
            name="avatar"
            style="width: auto;"
            :style="{ width: (fileList.length + 1) * 120 + 'px' }"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="true"
            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
            @change="handleChange2"
          >
            <div>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">
                点击上传音频
              </div>
            </div>
          </a-upload>
        </div>
        <div class="upload-tip">
          单个图片/视频不能超过500M;上传上限100张图片
        </div>
      </section>

      <section class="section">
        <div class="z-title">观察对象 <span>*</span></div>
        <div class="content">
          <a-space>
            <a-button
              v-for="(item, index) in form.students"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;"
              >{{ item }} <a-icon style="color: #999;" type="lock"
            /></a-button>
            <a-button shape="round" size="small" @click="showAddStudents = true"
              ><a-icon type="plus" />选择添加孩子</a-button
            >
          </a-space>
        </div>
      </section>

      <section class="section">
        <div class="z-title">关联领域 <span>*</span></div>
        <div class="content">
          <a-space>
            <a-button
              @click="form.range.splice(index, 1)"
              v-for="(item, index) in form.range"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;"
              >{{ item }} <a-icon style="color: #999;" type="close"
            /></a-button>
            <a-button shape="round" size="small" @click="showRange = true"
              ><a-icon type="plus" />添加/选择关联领域</a-button
            >
          </a-space>
        </div>
      </section>

      <section class="section">
        <div class="z-title">发展阶段 <span>*</span></div>
        <section class="card">
          <div
            class="names"
            style="background: #F2F9FE;padding: 5px 8px;border-radius: 2px;margin: 10px 0;"
          >
            {{ form.students.join("、") }}
          </div>
          <div class="bea-list">
            <bea-list labelPos="block" backgroundColor="#fff"></bea-list>
          </div>
        </section>
        <div class="content">
          <a-space>
            <a-button
              @click="form.level.splice(index, 1)"
              v-for="(item, index) in form.level"
              shape="round"
              size="small"
              :key="index"
              class="student"
              style="color: #999;"
              >{{ item }} <a-icon style="color: #999;" type="close"
            /></a-button>
            <a-button shape="round" size="small" @click="handleAddbeva"
              ><a-icon type="plus" />添加行为表现</a-button
            >
          </a-space>
        </div>
      </section>

      <section class="section">
        <div class="z-title">记录时间 <span>*</span></div>
        <div class="content">
          <a-date-picker v-model="form.startTime" />
        </div>
      </section>

      <a-modal
        width="720px"
        :visible="showAddStudents"
        @cancel="showAddStudents = false"
        @ok="handleAddStudents"
        title="选择孩子"
        :bodyStyle="{ padding: '10px 20px' }"
        centered
      >
        <a-row>
          <a-checkbox :checked="checkAll" @change="handleSelectAllStudents">
            全部
          </a-checkbox>
        </a-row>
        <div v-for="(item, index) in plainOptions" :key="index" class="range">
          <div class="Up">{{ item.label }}</div>
          <a-checkbox-group v-model="checkedList[index]">
            <a-row>
              <a-col
                v-for="(label, index2) in item.childs"
                :key="index2"
                :span="6"
              >
                <a-checkbox :value="label">
                  {{ label }}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </div>
      </a-modal>

      <a-modal
        width="720px"
        :visible="showRange"
        @cancel="showRange = false"
        @ok="handleAddRange"
        title="选择领域"
        :bodyStyle="{ padding: '10px 20px' }"
        centered
      >
        <div v-for="(item, index) in rangeList" :key="index" class="range">
          <div class="Up">{{ item.label }}</div>
          <a-checkbox-group v-model="rangeCheckedList[index]">
            <a-row>
              <a-col
                v-for="(label, index2) in item.childs"
                :key="index2"
                :span="6"
              >
                <a-checkbox :value="label">
                  {{ label }}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import beaList from "../../components/bea-list-add.vue";

export default {
  data() {
    return {
      showPlate: false,
      showPush: false,
      selectNum: 0,
      form: {
        type: 1,
        content: "",
        observe: [
          {
            content: "",
            fileList: [],
            fileList2: [],
          },
        ],
        content2:
          "在园表现积极、乖巧懂事、能够自觉遵守生活纪律和规范，是老师的心头好帮手。你人小可样样事情敢超人先，你做的都比别人好，你画的画真的好看，老师十分喜欢。构图合理富有创意。希望小小呗能更加活泼，更大胆些，上课积极举手发言，乖巧懂事",
        content3: "",
        content4: "",
        content5: "",
        students: ["王泽"],
        range: ["社会适应"],
        status: 1,
        startTime: "2024-10-29 00:00:00",
        cj: [],
      },
      selectType: 1,
      loading: false,
      fileList: [],
      fileList2: [],
      showAddStudents: false,
      showAddCj: false,
      plainOptions: [
        {
          label: "S",
          childs: ["宋星星", "史爱民"],
        },
        {
          label: "C",
          childs: ["陈晨", "陈星宇"],
        },
      ],
      checkedList: [],
      showRange: false,
      rangeCheckedList: [],
      rangeList: [
        {
          label: "健康领域",
          childs: ["身心状况", "动作与发展", "生活习惯和技能"],
        },
        {
          label: "语言领域",
          childs: ["倾听与表达", "阅读与书写准备"],
        },
        {
          label: "社会领域",
          childs: ["社会适应", "人际交往"],
        },
        {
          label: "科学领域",
          childs: ["科学探究", "数学认知"],
        },
        {
          label: "艺术领域",
          childs: ["感受与欣赏", "表现与创造"],
        },
        {
          label: "其他",
          childs: ["自定义", "家长会"],
        },
      ],
      activityList: [
        {
          label: "节日活动",
          childs: [
            "元旦",
            "清明节",
            "父亲节",
            "重阳节",
            "春节",
            "劳动节",
            "教师节",
            "圣诞节",
            "元宵节",
            "儿童节",
            "国庆节",
            "感恩节",
          ],
        },
        {
          label: "四季节气",
          childs: [
            "春天",
            "四季",
            "夏天",
            "二十四节气",
            "秋天",
            "天气气候",
            "冬天",
          ],
        },
        {
          label: "社会交往",
          childs: [
            "交朋友",
            "我的家",
            "玩玩具",
            "我的祖国",
            "各行各业的人",
            "我自己",
          ],
        },
        {
          label: "科学探索",
          childs: [
            "食物",
            "交通工具",
            "城市",
            "生活工具",
            "动物",
            "环保",
            "植物",
          ],
        },
        {
          label: "其他",
          childs: ["自定义", "家长会"],
        },
      ],
      showActivity: false,
      activityCheckedList: [],
      cjCheckedList: [],
      cjList: [
        {
          label: "生活",
          childs: [
            "来离园活动",
            "餐点活动",
            "饮水活动",
            "如厕盥洗活动",
            "午睡",
            "户外散步",
          ],
        },
        {
          label: "游戏",
          childs: ["角色游戏", "表演游戏", "结构游戏", "自由活动"],
        },
        {
          label: "学习",
          childs: [
            "集体教学",
            "益智区",
            "生活区",
            "语言区",
            "科学探索",
            "美工区",
            "音乐区",
          ],
        },
      ],
    };
  },
  components: {
    beaList,
  },
  computed: {
    formContent() {
      if (
        this.form.content ||
        this.form.content2 ||
        this.form.content3 ||
        this.form.content4 ||
        this.form.content5 ||
        this.form.range.length ||
        this.form.students.length ||
        this.form.cj.length
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    handleSelectAllStudents(e) {
      console.log(e);
      this.checkAll = e.target.checked;
      if (e.target.checked) {
        this.checkedList = [];
        this.plainOptions.forEach((element, index) => {
          this.checkedList.push([...element.childs]);
        });
        console.log(this.checkedList);
      } else {
        this.form.students = [];
        this.checkedList = [];
        this.plainOptions.forEach((element, index) => {
          this.checkedList.push([]);
        });
      }
    },
    handleShowPlate() {
      console.log(this.formContent);
      if (this.formContent) {
        this.$confirm({
          title: "更换模板后，已经输入的内容不能同步保存哦",
          type: "warning",
          centered: true,
          size: "small",
          icon: "exclamation-circle",
          onOk: () => {
            this.showPlate = true;
          },
          onCancel: () => {},
        });
      } else {
        this.showPlate = true;
      }
    },
    handleAddObserve() {
      this.form.observe.push({
        content: "",
        fileList: [],
        fileList2: [],
      });
    },
    handleAddbeva() {
      if (this.form.students.length < 1) {
        this.$message.error("请先选择观察对象");
        return;
      }

      this.$router.push("/observe/addLevel");
    },
    handleChangePlate() {
      this.form.type = this.selectType;
      this.showPlate = false;
    },
    onChange(e) {
      console.log(e);
      this.checkedList = e;
    },
    handleAddRange() {
      this.form.range = this.rangeCheckedList.flat();
      this.showRange = false;
    },
    handleAddStudents() {
      if (this.checkAll) {
        this.form.students = ["全部"];
      } else {
        this.form.students = this.checkedList.flat();
      }
      this.showAddStudents = false;
    },
    handleAddCj() {
      this.form.cj = this.cjCheckedList.flat();
      this.showAddCj = false;
    },
    handleAddActivity() {
      this.form.activity = this.activityCheckedList.flat();
      this.showActivity = false;
    },
    handleSave() {
      this.$message.loading({
        content: "保存中...",
        duration: 1,
      });

      setTimeout(() => {
        this.$router.back();
        this.$message.success("保存成功");
      }, 800);
    },
    handlePush() {
      this.$message.success("发布成功");
      setTimeout(() => {
        this.$router.back();
      }, 600);
    },
    handleChange1(info) {
      if (info.file.status === "uploading") {
        this.loading = true;
        this.fileList = [info.fileList];
      }

      setTimeout(() => {
        this.loading = false;
      }, 400);
    },
    handleChange2(info) {
      if (info.file.status === "uploading") {
        this.loading = true;
        this.fileList = [info.fileList];
      }

      setTimeout(() => {
        this.loading = false;
      }, 400);
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-checkbox-group {
  width: 100%;
}
section.section {
  border-bottom: 1px solid #ececec;
  padding: 20px 0;

  .z-title {
    position: relative;
    padding-left: 10px;
    line-height: 1.2;
    font-size: 14px;
    color: #555;
    font-weight: bold;
    &::before {
      position: absolute;
      content: "";
      left: 0;
      top: 0;
      width: 3px;
      background: #73b5de;
      height: 100%;
    }
    span {
      color: red;
      margin-left: 1px;
    }
    span.tip {
      color: #999;
      font-weight: 400;
      margin-left: 5px;
    }
  }

  .input {
    margin-top: 10px;
    position: relative;
    .number {
      position: absolute;
      right: 12px;
      bottom: 3px;
      font-size: 12px;
      color: #7a7a7a;
    }
  }

  .upload {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }
  .upload-tip {
    font-size: 12px;
    color: #999;
    width: 100%;
  }

  .content {
    margin-top: 20px;
  }
}

.range {
  margin: 10px 0;
  .Up {
    font-weight: 800;
    margin-bottom: 5px;
    font-size: 14px;
    font-family: "微软雅黑";
  }
}

.page {
  height: 100%;
  max-width: 900px;
  margin: 0 auto;
  .router {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    flex-direction: row;
    padding: 0 0px;
    color: #999;
    .back {
      display: flex;
      align-items: center;
      cursor: pointer;
      flex-direction: row;
      .name {
        margin-left: 5px;
        color: #999;
      }
    }
  }

  .srcoll {
    height: calc(100% - 75px);
    overflow-y: auto;
    padding: 15px 20px;
    background: #fff;
    border-radius: 5px;
    .title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin-bottom: 20px;
    }
  }
}
.drawer-content {
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    padding: 15px;
    .title {
      flex: 1;
      text-align: left;
      margin-left: 2px;
      font-size: 16px;
      margin-bottom: 0;
      font-family: "微软雅黑";
      font-weight: bold;
      //字体平滑
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }

  .body {
    padding: 20px;
    .plate {
      margin-top: 20px;
      user-select: none;
      .item {
        font-size: 12px;
        width: 120px;
        height: 155px;
        border-radius: 5px;
        cursor: pointer;
        padding: 10px;
        margin-right: 10px;
        color: #555;
        position: relative;
        font-size: 14px;
        box-shadow: 2px 3px 6px 3px rgba($color: #0e6dc5, $alpha: 0.2);
        &::after {
          content: "";
          position: absolute;
          left: 10px;
          top: 50px;
          height: 5px;
          border-radius: 5px;
          width: 40px;
          background: #90bce6;
        }

        &::before {
          content: "";
          position: absolute;
          left: 10px;
          top: 60px;
          height: 5px;
          border-radius: 5px;
          width: 55px;
          background: #90bce6;
        }
      }
    }
  }
}

.selectCl {
  border: 1px solid #92b8cf !important;
  color: #fff !important;
  background: #7da2b9 !important;
  padding: 4px 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
  margin-top: 10px;
}
</style>
